/**
 * Register ambient typings so Monaco stops reporting
 * "Cannot find module 'react'" for JSX/JS projects.
 */
export function registerReactTypings(monaco) {
  const js = monaco.languages.typescript.javascriptDefaults;
  const ts = monaco.languages.typescript.typescriptDefaults;

  const opts = {
    target: monaco.languages.typescript.ScriptTarget.ESNext,
    allowNonTsExtensions: true,
    moduleResolution: monaco.languages.typescript.ModuleResolutionKind.NodeJs,
    module: monaco.languages.typescript.ModuleKind.ESNext,
    jsx: monaco.languages.typescript.JsxEmit.ReactJSX,
    allowJs: true,
    checkJs: false, // avoid noisy "cannot find module" without real node_modules in browser
    noEmit: true,
    esModuleInterop: true,
    allowSyntheticDefaultImports: true,
    skipLibCheck: true,
  };

  js.setCompilerOptions(opts);
  ts.setCompilerOptions(opts);

  js.setDiagnosticsOptions({
    noSemanticValidation: false,
    noSyntaxValidation: false,
    noSuggestionDiagnostics: true,
    diagnosticCodesToIgnore: [
      2307, // Cannot find module
      2792, // Cannot find module (TS)
      7016, // Could not find a declaration file
      7044, // parameter implicitly has 'any'
      7006,
      2339, // Property does not exist (often from missing types)
    ],
  });

  ts.setDiagnosticsOptions({
    noSemanticValidation: false,
    noSyntaxValidation: false,
    noSuggestionDiagnostics: true,
    diagnosticCodesToIgnore: [2307, 2792, 7016, 7044, 7006, 2339],
  });

  const reactShim = `
declare module 'react' {
  export type ReactNode = any;
  export type FC<P = {}> = (props: P & { children?: ReactNode }) => any;
  export type CSSProperties = Record<string, any>;
  export function useState<T>(init: T | (() => T)): [T, (v: T | ((p: T) => T)) => void];
  export function useEffect(effect: () => void | (() => void), deps?: any[]): void;
  export function useRef<T>(init: T): { current: T };
  export function useCallback<T extends (...args: any[]) => any>(fn: T, deps: any[]): T;
  export function useMemo<T>(fn: () => T, deps: any[]): T;
  export function useContext<T>(ctx: any): T;
  export function createContext<T>(defaultValue: T): any;
  export function createElement(type: any, props?: any, ...children: any[]): any;
  export function Fragment(props: { children?: any }): any;
  export function StrictMode(props: { children?: any }): any;
  export default any;
}
declare module 'react/jsx-runtime' {
  export const jsx: any;
  export const jsxs: any;
  export const Fragment: any;
}
declare module 'react-dom' {
  export function createRoot(el: any): { render(node: any): void };
  export default any;
}
declare module 'react-dom/client' {
  export function createRoot(el: any): { render(node: any): void };
}
declare module '*.css' { const c: any; export default c; }
declare module '*.scss' { const c: any; export default c; }
declare module '*.svg' { const c: any; export default c; }
declare module '*.png' { const c: any; export default c; }
`;

  const root = 'file:///node_modules/@types/';
  js.addExtraLib(reactShim, root + 'react-shim.d.ts');
  ts.addExtraLib(reactShim, root + 'react-shim.d.ts');
}
